module.exports = __webpack_public_path__ + "static/media/email-blue.2d39474a.svg";